export default __webpack_public_path__ + "static/media/empty_image2.2d4f78d0.svg";